export default {
    preloader: false,
    params: {
        process: null,
    },
    processes: [
        { id: 'rebuild_last_purchase_price', name: 'Reconstruir Precio Ultima Compra' },
    ],
};



// WEBPACK FOOTER //
// ./src/modules/special-processes/state.js